import { ComponentsMap } from '../constants/ComponentsMap';
import { ModuleConstants } from '../constants/modules';
import { RouteConstants } from '../constants/routes';
import { ScreenNames } from '../constants/screens';
import { generateImage } from '../utilities/utils';
import { ModuleRoutesComponentInterface } from './types';

const getModuleRoutes: ModuleRoutesComponentInterface = (pathname: string) => {
  return [
    {
      id: ModuleConstants.PUBLIC_MODULE_ID,
      route: RouteConstants.HOME,
      title: ScreenNames.HOME,
      icon: generateImage({
        name: 'home',
        alt: 'home icon',
        className: 'w-4 h-[0.9375rem]',
      }),
      component: ComponentsMap.Dashboard,
      sidebarVisibility: false,
    },
    {
      id: ModuleConstants.PUBLIC_MODULE_ID,
      route: RouteConstants.PRICING,
      title: ScreenNames.PRICING,
      icon: generateImage({
        name: 'currency-rupee-circle',
        alt: 'currency-rupee-circle icon',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.PUBLIC_MODULE_ID,
          route: RouteConstants.LIVE_PRICING,
          title: ScreenNames.LIVE_PRICING,
          component: ComponentsMap.LivePricing,
        },
        {
          id: ModuleConstants.PUBLIC_MODULE_ID,
          route: RouteConstants.SUGGESTED_PRICING,
          title: ScreenNames.SUGGESTED_PRICING,
          component: ComponentsMap.SuggestedPricing,
        },
        {
          id: ModuleConstants.PUBLIC_MODULE_ID,
          route: RouteConstants.BUNDLE_LIVE_PRICING,
          title: ScreenNames.BUNDLE_LIVE_PRICING,
          component: ComponentsMap.BundleLivePricing,
        },
        {
          id: ModuleConstants.PUBLIC_MODULE_ID,
          route: RouteConstants.BUNDLE_SUGGESTED_PRICING,
          title: ScreenNames.BUNDLE_SUGGESTED_PRICING,
          component: ComponentsMap.BundleSuggestedPricing,
        },
        {
          id: ModuleConstants.PUBLIC_MODULE_ID,
          route: RouteConstants.CBP_SUGGESTION_LISTING,
          title: ScreenNames.CBP_SUGGESTION_LISTING,
          component: ComponentsMap.CBPSuggestions,
        },
        {
          id: ModuleConstants.PUBLIC_MODULE_ID,
          route: RouteConstants.REJECTED_BATCHES,
          title: ScreenNames.REJECTED_BATCHES,
          component: ComponentsMap.RejectedBatches,
        },
        {
          id: ModuleConstants.PUBLIC_MODULE_ID,
          route: RouteConstants.HISTORICAL_PRICING,
          title: ScreenNames.HISTORICAL_PRICING,
          component: ComponentsMap.HistoricalPricing,
        },
        {
          id: ModuleConstants.PUBLIC_MODULE_ID,
          route: RouteConstants.CAMPAIGN_SUGGESTIONS,
          title: ScreenNames.CAMPAIGN_SUGGESTIONS,
          component: ComponentsMap.CampaignSuggestions,
        },
      ],
    },
    {
      id: ModuleConstants.PUBLIC_MODULE_ID,
      route: RouteConstants.CAMPAIGNS,
      title: ScreenNames.CAMPAIGNS,
      icon: generateImage({
        name: 'calendar-white',
        alt: 'calendar-icon',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.PUBLIC_MODULE_ID,
          route: RouteConstants.DAILY_CAMPAIGNS,
          title: ScreenNames.DAILY_CAMPAIGNS,
          component: ComponentsMap.DailyCampaigns,
        },
        {
          id: ModuleConstants.PUBLIC_MODULE_ID,
          route: RouteConstants.YEARLY_CAMPAIGNS,
          title: ScreenNames.YEARLY_CAMPAIGNS,
          component: ComponentsMap.YearlyCampaigns,
        },
      ],
    },
    {
      id: ModuleConstants.PO_APPROVALS_ID,
      route: RouteConstants.PO_APPROVAL,
      title: ScreenNames.PO_APPROVAL,
      icon: generateImage({
        name: 'check-circle',
        alt: 'check-circle-icon',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.POApproval,
    },
    {
      id: ModuleConstants.RETURN_PO_ACKNOWLEDGEMENT_ID,
      route: RouteConstants.RETURN_PO_ACKNOWLEDGEMENT,
      title: ScreenNames.RETURN_PO_ACKNOWLEDGEMENT,
      icon: generateImage({
        name: 'check-circle',
        alt: 'check-circle-icon',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.ReturnPOAck,
    },
    {
      id: ModuleConstants.PUBLIC_MODULE_ID,
      route: RouteConstants.COUPONS,
      title: ScreenNames.COUPONS,
      icon: generateImage({
        name: 'coupon-icon',
        alt: 'coupon-icon',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.CouponsAndBankOffers,
    },
    {
      id: ModuleConstants.PUBLIC_MODULE_ID,
      route: RouteConstants.RECEIVABLES,
      title: ScreenNames.RECEIVABLES,
      icon: generateImage({
        name: 'box',
        alt: 'box-icon',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.Receivables,
    },
    {
      id: ModuleConstants.PUBLIC_MODULE_ID,
      route: RouteConstants.SEGMENT,
      title: ScreenNames.SEGMENT,
      icon: generateImage({
        name: 'box',
        alt: 'box-icon',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.Segment,
    },
    {
      id: ModuleConstants.SKU_ID,
      route: RouteConstants.SKU,
      title: ScreenNames.SKU,
      icon: generateImage({
        name: 'shopping-bag',
        alt: 'shopping-icon',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.Sku,
    },
    {
      id: ModuleConstants.PUBLIC_MODULE_ID,
      route: RouteConstants.EXPERIMENTS,
      title: ScreenNames.EXPERIMENTS,
      icon: generateImage({
        name: 'box',
        alt: 'box-icon',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.Experiments,
    },
    {
      id: ModuleConstants.REPORTS_ID,
      route: RouteConstants.REPORTS,
      title: ScreenNames.REPORTS,
      icon: generateImage({
        name: 'report',
        alt: 'report-icon',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.Reports,
    },
    {
      id: ModuleConstants.PO_MANAGEMENT_ID,
      route: RouteConstants.PO,
      title: ScreenNames.PO,
      icon: generateImage({
        name: 'po-logo',
        alt: 'po-logo',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.PO_SUMMARY_ID,
          route: RouteConstants.PO_SUMMARY,
          title: ScreenNames.PO_SUMMARY,
          component: ComponentsMap.PoSummary,
          children: [
            {
              id: ModuleConstants.PO_SUMMARY_ID,
              route: RouteConstants.PO_SUMMARY_ID,
              title: String(pathname.split('/').at(-1)),
              component: ComponentsMap.PoSummaryId,
              sidebarVisibility: false,
            },
          ],
        },
        {
          id: ModuleConstants.BULK_PO_CREATION,
          route: RouteConstants.BULK_PO_CREATION,
          title: ScreenNames.BULK_PO_CREATION,
          component: ComponentsMap.BulkPoCreation,
        },
        {
          id: ModuleConstants.BULK_JOBS_ID,
          route: RouteConstants.BULK_JOBS,
          title: ScreenNames.BULK_JOBS,
          component: ComponentsMap.BulkJobs,
        },
        {
          id: ModuleConstants.PO_REPORTS_ID,
          route: RouteConstants.BULK_REPORTS,
          title: ScreenNames.REPORTS,
          component: ComponentsMap.BulkReports,
        },
      ],
    },
    {
      id: ModuleConstants.ASN_ID,
      route: RouteConstants.ASN,
      title: ScreenNames.ASN,
      icon: generateImage({
        name: 'asn',
        alt: 'asn-icon',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.ASN,
    },
    {
      id: ModuleConstants.PRICING_SUMMARY_ID,
      route: RouteConstants.PRICING_SUMMARY,
      title: ScreenNames.PRICING_SUMMARY,
      icon: generateImage({
        name: 'currency-rupee-circle',
        alt: 'currency-rupee-circle',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.PricingSummary,
    },
    {
      id: ModuleConstants.UPLOAD_PRICING_ID,
      route: RouteConstants.UPLOAD_PRICING,
      title: ScreenNames.UPLOAD_PRICING,
      component: ComponentsMap.UploadPricing,
      icon: generateImage({
        name: 'upload-icon',
        alt: 'upload-icon',
        className: 'w-3 h-3',
      }),
    },
    {
      id: ModuleConstants.APPROVALS_ID,
      route: RouteConstants.APPROVALS,
      title: ScreenNames.APPROVALS,
      icon: generateImage({
        name: 'approvals-logo',
        alt: 'approvals-logo',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.Approvals,
    },
    {
      id: ModuleConstants.USER_MANAGEMENT_ID,
      route: RouteConstants.USER_MANAGEMENT,
      title: ScreenNames.USER_MANAGEMENT,
      icon: generateImage({
        name: 'users-02',
        alt: 'users-icon',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.UserManagement,
    },
  ];
};

export default getModuleRoutes;
